<template>
  <div id="DeliveryCompleted">
    <h4 class="content" :class="status.template.code" v-html="status.template.down"></h4>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DeliveryCompleted',
  computed: {
    ...mapGetters('delivery', {
      status: 'getStatus'
    }),
  }
}
</script>
